<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <h6>Email Subject</h6>
        <iq-card class="p-2">
          <template v-slot:body>
            <div class="emailView">
              <p>{{ propAdminEmailTempObj.email_subject }}</p>
            </div>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <h6>Email Body</h6>
        <iq-card class="p-2">
          <template v-slot:body>
            <div class="emailView">
              <div v-html="propAdminEmailTempObj.email_body"></div>
            </div>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { socialvue } from "../../../config/pluginInit"
export default {
  name: "adminEmailTemplateEdit",
  components: {},
  props: {
    propOpenedInModal: {
      type: Boolean,
      default: false
    },
    propAdminEmailTempObj: {
      type: Object,
      default: function () {
        return {
          "email_template_id": "",
          "email_template_name": "",
          "module_object_id": "",
          "module_name": "",
          "email_subject": "",
          "email_body": ""
        }
      }
    }
  },
  data () {
    return {
      cvCardTitle: "View Email Template"
    }
  },
  mounted () {
    socialvue.index()
  },
  methods: {}
}
</script>
